import publicCta from '../content/publicCta.json';

/**
 * Portal de pagos PSE para asociados.
 * Prioridad: VITE_PSE_PAYMENTS_URL (.env) → psePaymentsUrl en publicCta.json
 */
export const PSE_PAYMENTS_URL =
  import.meta.env.VITE_PSE_PAYMENTS_URL?.trim() || String(publicCta.psePaymentsUrl || '').trim();

export const PSE_PAYMENTS_LABEL = publicCta.psePaymentsLabel || 'Pagos PSE';

/** Logo PSE en `public/logo-PSE_.jpg` */
export const PSE_LOGO_SRC = '/logo-PSE_.jpg';

/** Si no hay URL de PSE, el botón lleva a contacto. */
export const PSE_PAYMENTS_HREF = PSE_PAYMENTS_URL || '/contacto';

export const PSE_PAYMENTS_IS_EXTERNAL = Boolean(PSE_PAYMENTS_URL);
